import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

// Components
import { PageHeader } from "../components/PageSpecificComponents";
import { Card, Body, EmptyState } from "../components/UI";
import { Paragraph } from "../components/typography";
import Row from "../components/lists/Row";
import ServiceRequestItem from "../components/lists/serviceRequests/ServiceRequest.item";

// Builders

// Actions
import {
  getServiceRequests,
  openDeclineReason,
  openTicketDetails
} from "../redux/actions/service-requests.actions";

// Services
import { disableScroll, isEmpty } from "../utils";

// Styles
import { ServiceRequestsStyles } from "../pagesStyles/serviceRequests.styles";

const serviceRequestsTableHead = [
  { className: "ID", title: "ID" },
  { className: "user", title: "User" },
  { className: "serviceType", title: "Service Type" },
  { className: "bookedFor", title: "Booked For" },
  { className: "messages", title: "" },
  { className: "actions", title: "" }
];

// const newRequests = [1, 2, 3];

const ServiceRequests = () => {
  const dispatch = useDispatch();
  const { activeBranch } = useSelector(state => state.app);
  const { requests } = useSelector(state => state.serviceRequestsPage);

  useEffect(() => {
    dispatch(getServiceRequests());
  }, [activeBranch, dispatch]);

  return (
    <ServiceRequestsStyles>
      <PageHeader title="Service Requests" />
      <Card className="tableCard" rounded>
        <div className="tableScroll">
          <Body className="tableHead">
            {serviceRequestsTableHead.map(({ title, className }, i) => (
              <Paragraph className={`tableHeadTitle ${className}`} key={i}>
                {title}
              </Paragraph>
            ))}
          </Body>
          {isEmpty(requests) ? (
            <EmptyState
              title="No service requests"
              subtitle="New requests from drivers will show up here."
            />
          ) : (
            requests.map(req => (
              <Row
                key={req.id}
                className="serviceRow"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  disableScroll();
                  dispatch(openTicketDetails(req.id, req.branchId));
                }}
              >
                <ServiceRequestItem
                  request={req}
                  declineAction={e => {
                    e.stopPropagation();
                    disableScroll();
                    dispatch(openDeclineReason(req.id, req.branchId));
                  }}
                />
              </Row>
            ))
          )}
        </div>
      </Card>

      {/* Request detail drawer + decline modal are rendered globally
          (GlobalServiceDrawers in AppShell) — openTicketDetails /
          openDeclineReason above drive them through redux. */}
    </ServiceRequestsStyles>
  );
};

export default ServiceRequests;
